import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '../common/Grid';
import colors from "../utilities/colors";
import spacings from "../utilities/spacings";
import Button from "../common/Button";

const FooterWrapper = styled.div`
  text-align: center;
  font-size: 13px;
  color: ${colors.darkGrey};
  padding: ${spacings.m} 0;
  border-top: 1px solid ${colors.lightGrey};
  margin-top: ${(props) => props.marginTop ? props.marginTop : spacings.xl };
  
  .btn-link {
    display: inline;
    font-size: 12px;
    color: ${colors.primary};
  }
`;

const Footer = props => {
    return (
        <Grid.Wrapper>
            <FooterWrapper marginTop={props.marginTop}>
                &copy; SEO USA, all rights reserved.
                <Button class={'btn-link'} label={'Terms of Use and Privacy Policy'} tag={'a'} href={'https://www.seo-usa.org/terms-of-use-and-privacy-policy/'} />
            </FooterWrapper>
        </Grid.Wrapper>
    );
};

Footer.propTypes = {
    marginTop: PropTypes.string,
};

export default Footer;
